<template>
	<SensorTrack :datas="item.sensorData">
		<nuxt-link-enhance
			class="h-[50px] box-border flex flex-1 items-center px-5 py-3 bm-size-3_5 leading-6 font-medium cursor-pointer hover:bm-bg-gray-100 relative"
			:project="item.project"
			:to="item.to"
			exact
		>
			<span>{{ $t('bmui-navigator-bar.common_app_messages_title') }}</span>
			<span :class="[$style.CountDot, 'absolute right-4']" v-show="badgeCount > 0">{{
				`${badgeCount > 99 ? `99+` : `${badgeCount}`}`
			}}</span>
		</nuxt-link-enhance>
	</SensorTrack>
</template>
<script lang="ts">
import { computed } from 'vue';
import { PROJECT_MAP } from '../../config';
import SensorTrack from '../SensorTrack.vue';
import { IMsgClazzItem } from './types';
import { useStore } from '~/common/js/patch';
import NuxtLinkEnhance from '../NuxtLinkEnhance.vue';
export default {
	components: {
		SensorTrack,
		NuxtLinkEnhance
	},
	props: {},
	setup() {
		const store = useStore() as any;
		const item = computed(() => {
			return {
				value: 'messages',
				to: '/messages',
				project: PROJECT_MAP.MASTER,
				sensorData: {
					sensorEventName: 'Messages',
					module_name: '站内信',
					button_name: '站内信',
				},
			};
		});
		const msgClazzList = computed<IMsgClazzItem[]>(() => {
			return store.state.msgStationClazzList || [];
		});
		const badgeCount = computed(() => {
			let count = 0;
			msgClazzList.value.forEach((item: IMsgClazzItem) => {
				count += item.unreadCount;
			});
			return count;
		});
		return {
			item,
			badgeCount,
		};
	},
};
</script>
<style lang="less" module>
.Message {
	display: flex;
	padding-right: 12px;
	align-items: center;
}
.CountDot {
	display: block;
	color: #ffffff;
	background-color: #ff532f;
	border-radius: 30px;
	line-height: 12px;
	font-size: 10px;
	padding: 1px 5px;
	min-width: 24px;
	text-align: center;
	box-sizing: border-box;
	height: 14px;
	margin-left: auto;
}
</style>
